import { Label } from '@facephi/ui-react';
import { useTranslation } from 'react-i18next';
import { operationsMock } from '../../../api';
import { StackedBar } from '../graph';
import { CardBaseHeaderStyled, OperationsCard } from './Styles';

export const Operations = () => {
  const { t } = useTranslation();

  const operationsData = operationsMock;

  return (
    <OperationsCard>
      <CardBaseHeaderStyled noBorder small>
        <Label fontSize="21" semibold>
          {t('Risk level')}
        </Label>
      </CardBaseHeaderStyled>
      <StackedBar
        {...operationsData}
        style={{
          height: '100%',
          width: '100%',
        }}
      />
    </OperationsCard>
  );
};
